import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-6 md:mt-8 text-center">
      <p className="caption text-muted-foreground mb-4">
        Already have an account?
      </p>
      <Button
        variant="outline"
        size="default"
        onClick={() => navigate('/login')}
        fullWidth
      >
        Sign In Instead
      </Button>
    </div>
  );
};

export default LoginPrompt;